// src/pages/auth/Login.tsx

import LoginForm from "@/components/auth/components/LoginForm";
import { SIDE_IMAGE, LOGO } from "@/components/auth/assets";

export default function Login() {
  return (
    <div className="relative min-h-screen bg-gradient-to-br from-sky-500 to-sky-600">
      {/* PAGE CONTAINER: centered card */}
      <div className="mx-auto flex min-h-screen max-w-6xl items-center justify-center px-4 py-8 md:py-14">
        <div className="relative w-full overflow-hidden rounded-3xl bg-white shadow-[0_25px_80px_rgba(2,6,23,0.25)]">
          <div className="grid grid-cols-1 md:grid-cols-2">
            {/* LEFT: image panel (hidden on mobile) */}
            <div className="relative hidden md:block">
              <img
                src={SIDE_IMAGE}
                alt="Scenic travel collage"
                className="h-full w-full object-cover"
                loading="lazy"
              />
              {/* subtle overlay for readability if we ever add text */}
              <div className="pointer-events-none absolute inset-0 bg-black/0" />
            </div>

            {/* RIGHT: form panel */}
            <div className="relative flex items-center justify-center px-6 py-10 md:px-12">
              <div className="w-full max-w-md">
                {/* brand logo */}
                <div className="mb-5 flex justify-center">
                  <img src={LOGO} alt="Tranzy Tours" className="h-12" />
                </div>

                <h1 className="text-center text-3xl font-bold text-sky-700">
                  Welcome
                </h1>
                <p className="mt-1 text-center text-xs text-gray-500">
                  Login with <span className="font-semibold">Username</span>
                </p>

                {/* form */}
                <LoginForm />

                {/* small footer (optional) */}
                <p className="mt-6 text-center text-[11px] leading-5 text-gray-400">
                  By signing in you agree to our{" "}
                  <a href="/terms" className="underline decoration-sky-400 hover:text-gray-500">
                    Terms
                  </a>{" "}
                  and{" "}
                  <a href="/privacy" className="underline decoration-sky-400 hover:text-gray-500">
                    Privacy Policy
                  </a>
                  .
                </p>
              </div>
            </div>
            {/* end RIGHT */}
          </div>
        </div>
      </div>
    </div>
  );
}
